import { Box, FloraButton, Flex } from '@grupoboticario/flora-react'

import type { AccelerationContentDetails, AccelerationDetailRichItem } from '../../AccelerationForm.types'
import { createDetailRichItem } from '../../utils/detailRichItems'
import { RichTextItem } from './RichTextItem'

export interface RichTextItemListProps {
  field: 'steps' | 'rules'
  items: AccelerationDetailRichItem[] | undefined
  readOnly?: boolean
  maxItems: number
  maxTextLength: number
  createIdPrefix: string
  rowLabel: string
  addButtonLabel: string
  onChange: (field: keyof AccelerationContentDetails, value: AccelerationContentDetails[typeof field]) => void
}

export const RichTextItemList = ({
  field,
  items,
  readOnly = false,
  maxItems,
  maxTextLength,
  createIdPrefix,
  rowLabel,
  addButtonLabel,
  onChange
}: RichTextItemListProps) => {
  const list = items?.length ? items : []
  const canAdd = list.length < maxItems

  const patchList = (next: AccelerationDetailRichItem[]) => {
    onChange(field, next)
  }

  const add = () => {
    if (!canAdd || readOnly) return
    patchList([...list, createDetailRichItem(createIdPrefix)])
  }

  const updateItem = (index: number, html: string) => {
    patchList(list.map((item, i) => (i === index ? { ...item, html } : item)))
  }

  const deleteItem = (index: number) => {
    if (readOnly) return
    patchList(list.filter((_, i) => i !== index))
  }

  return (
    <Box>
      <Flex direction="column" gap="$3">
        {list.map((item, index) => (
          <RichTextItem
            key={item.id}
            item={item}
            index={index}
            label={rowLabel}
            readOnly={readOnly}
            canDelete={list.length > 1}
            maxTextLength={maxTextLength}
            onUpdate={updateItem}
            onDelete={deleteItem}
          />
        ))}
      </Flex>

      {!readOnly && (
        <Box css={{ marginTop: '$1' }}>
          <FloraButton disabled={!canAdd} hierarchy="secondary" onClick={add} type="button">
            {addButtonLabel}
          </FloraButton>
        </Box>
      )}
    </Box>
  )
}
